import { useEffect } from 'react';
import posthog from 'posthog-js';
import {
  getBasePortalProperties,
  getStoredPortalIdentity,
  registerPortalContext,
} from '@lib/monitoring';

const PH_KEY = import.meta.env.VITE_PH_KEY as string | undefined;
const PH_HOST = '/ph';

let initialized = false;

export function usePH() {
  useEffect(() => {
    if (initialized) return;
    initialized = true;

    try {
      if (!PH_KEY) {
        console.warn('[LASSO] PH init skipped: key not set');
        return;
      }

      const { customerId, storeId } = getStoredPortalIdentity();

      posthog.init(PH_KEY, {
        api_host: PH_HOST,
        ui_host: 'https://us.posthog.com',
        person_profiles: 'identified_only',
        capture_pageview: true,
        capture_pageleave: true,
        autocapture: false,
        disable_session_recording: true,
        persistence: 'localStorage+cookie',
        loaded: (instance) => {
          instance.register(
            getBasePortalProperties({
              customer_id: customerId,
              store_id: storeId,
            }),
          );
        },
      });
    } catch (error) {
      console.warn('[LASSO] PH init failed:', error);
    }
  }, []);

  useEffect(() => {
    const { customerId, storeId } = getStoredPortalIdentity();

    registerPortalContext({
      customer_id: customerId,
      store_id: storeId,
    });
  }, []);
}
